import { z } from "zod/v4";

/**
 * Pick only the keys defined in the Shared schema — strips meta fields
 * before sending to the AI. Used as the default `toAiFormat` in handlers.
 *
 * Deliberately its own file, not part of `modHandlerRegistry.ts`: every mod
 * handler imports this, and `modHandlerRegistry.ts` imports every mod
 * handler to build its registry object — putting this function there made
 * that an 8-way circular import (registry -> handler -> registry), which
 * only "worked" by luck of module evaluation order. A leaf file with no
 * back-imports has no such cycle.
 */
export function pickSharedFields<TShared>(
  schema: z.ZodObject<z.ZodRawShape>,
  mod: object
): TShared {
  const result: Record<string, unknown> = {};
  const modRec = mod as Record<string, unknown>;
  for (const key of Object.keys(schema.shape)) {
    if (key in modRec) {
      result[key] = modRec[key];
    }
  }
  return result as TShared;
}
